"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = void 0;
const react_1 = __importDefault(require("react"));
const bind_1 = __importDefault(require("classnames/bind"));
const flex_module_scss_1 = __importDefault(require("./flex.module.scss"));
class Flex extends react_1.default.Component {
    render() {
        var type = this.props.hasOwnProperty("type") ? this.props.type : "";
        var style = this.props.hasOwnProperty("style") ? this.props.style : {};
        type = "flex " + type;
        var cx = bind_1.default.bind(flex_module_scss_1.default);
        var className = cx(type.split(" "));
        return (react_1.default.createElement("div", { className: className, style: style }, this.props.children));
    }
}
exports.Flex = Flex;
//# sourceMappingURL=flex.js.map